import { snakeStore, SORT_COLUMN, SORT_DIRECTION } from '@app/plugins/vuex-async-pagginate';
import { StatsService } from '@autocaller_v2/services/StatsService';

export const table = snakeStore(
  {
    state: {
      [SORT_COLUMN]: 'state',
      [SORT_DIRECTION]: 'desc'
    },
    actions: {
      getData: (_, params) => StatsService.getListExtend(params)
    }
  },
  true
);
